import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'; 
import queryString from 'query-string';

import { getApiDatas, strDateToFrLong, strDateToFrHour, urlToHost } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { CONST_EventTypes } from "../data/const"

import ObjRetour from "./inc/ObjRetour";

class PageSessionWeb extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiDatas:[],
			messageError:"",
		}
	}
	componentDidMount() {
		var oParams = queryString.parse(window.location.search);
		if(oParams.erid !== undefined){
			getApiDatas(`/apiaox/Event/GetDataPageSessionWeb?erid=${encodeURIComponent(oParams.erid)}`)
			.then((apiDatas) => { 
                this.setState({ apiDatas:apiDatas })
                //error redirect home
                if(apiDatas?.Error === 'ERROR'){
                    window.location.href =  urlToHost('');
                }
                //redirect auto lien teams
                if (!(apiDatas?.Error) && apiDatas.TeamsLink) { 
                    window.location.href = apiDatas.TeamsLink;
                }
            })
		}

		document.body.classList.add('pg_websession')    //!! ne s'applique pas si MainHeader sClassForPage
		window.scrollTo(0,0);
  	}
	componentWillUnmount() {
		document.body.classList.remove('pg_formation_detail')
	}
	render() {
		const apiDatas = this.state.apiDatas;

		return (<>
			<ObjRetour/>
			
            { apiDatas.EventSession && apiDatas.EventSession.Event && <>
                <section className="obj_section section_websession_detail">
                    <div className="ctn_section">
                        <div className="ctn_title">
                            <h1 className="t_title">
                                {apiDatas.EventSession.Event.Event_Title}
                            </h1>
                            <div className="ctn_row">
                                <div className={`obj_formation_detail
                                                    ${' ' + CONST_EventTypes[apiDatas.EventSession.Event.EventType_Code].css}
                                                    ${' ' + apiDatas.EventSession.Event.Brand.Brand_CssClass}
                                                `}>
						            <div className="ctn_row">
                                        <div className="ctn_image">
                                            <div className="ctn_visuel">
                                                <img src={urlToHost(apiDatas.EventSession.Event.Event_MediaUrl)} alt={apiDatas.EventSession.Event.Event_MediaAlt}/>
                                            </div>

                                            <div className="ctn_logo">
                                                <img src={urlToHost(apiDatas.EventSession.Event.Brand.Brand_LogoUrl)} alt={apiDatas.EventSession.Event.Brand.Brand_Name}/>
                                            </div>
                                        </div>

                                        <div className="ctn_text">	
                                            <ul className="list_infos">
                                                <li className="t_date">
                                                    {`${strDateToFrLong(apiDatas.EventSession.EventSession_StartDate)}`}
                                                </li>
                                                
                                                <li className="t_info">
                                                    {`${strDateToFrHour(apiDatas.EventSession.EventSession_StartDate)}`}
                                                </li>
                                            </ul>

                                            <div class="t_desc">
                                                {apiDatas.Error === 'ERROR_STARTDATE' && <>
                                                    <p class="t_desc">La session n'a pas encore commencée.</p>
                                                    <p class="t_desc">Veuillez réessayer plus tard</p>
                                                    <div className="ctn_cta">
                                                        <button className="obj_cta" type="button" onClick={() => window.location.reload(false)}>je me connecte à la session</button>
                                                    </div>
                                                </>}
                                                {apiDatas.Error === 'ERROR_ENDDATE' && <>
                                                    <p class="t_desc">{this.props.t('SessionWeb_ErrorEndDate')}</p>
                                                </>}
                                                {apiDatas.Error === 'ERROR_CANCELED' && <>
                                                    <p class="t_desc">La session est annulée</p>
                                                </>}
                                                {apiDatas.Error === '' && !apiDatas.TeamsLink && <>
                                                    <p>lien invalide</p>
                                                </>}
                                                {apiDatas.Error === '' && apiDatas.TeamsLink && <>
                                                    <div className="ctn_cta mb_20">
                                                        <button className="obj_cta" type="button" onClick={() => (window.location.href = apiDatas.TeamsLink)}>
                                                            Je me connecte à la session
                                                        </button>
                                                    </div>


                                                    <a href={apiDatas.TeamsLink}>lien vers la session</a>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                    </div>
			    </section>
            </>}
		</>)
	}
}

export default withTranslation()(PageSessionWeb)